import { render, staticRenderFns } from "./addPhone.vue?vue&type=template&id=c40ed45c&scoped=true&"
import script from "./addPhone.vue?vue&type=script&lang=js&"
export * from "./addPhone.vue?vue&type=script&lang=js&"
import style0 from "./addPhone.vue?vue&type=style&index=0&id=c40ed45c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40ed45c",
  null
  
)

export default component.exports